import type { QueryRequest } from '../../gen/types/platform'

/**
 * Required fields that consumers must always provide when constructing a query request.
 * All other QueryRequest fields can be overridden via `overrides`.
 */
type RequiredQueryFields = Pick<QueryRequest, 'root_entity' | 'fields'>

/**
 * Creates a QueryRequest with sensible defaults for all required fields.
 *
 * When the Horizon schema adds new required fields to QueryRequest,
 * only this function needs updating — not every consumer. Consumers provide
 * the fields they care about; everything else gets a safe default.
 */
export function createQueryRequest(
  overrides: Partial<QueryRequest> & RequiredQueryFields,
): QueryRequest {
  return {
    context: 'clients',
    ...overrides,
  }
}
